export var DISCUSSION_AREA = "Discussion";

export var CREATE_ATTACHMENT = "MarkdownInputWidget.CreateAttachment";
export var MARKDOWN_PASTETYPE_HTML_BUTTON_CLICKED = "MarkdownToolbar.MarkdownHTMLButtonClicked";
